import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as componentTypes from "../../../../constants/componentTypes";
import * as navigationActions from "../../../../actions/navigationActions";
import * as searchPanelActions from "../../../../actions/searchPanelActions";
import * as modelHelper from "../../../../helpers/modelHelper";

import Button from "../../../../components/global/generic/Button";
import CompetitiveColorsPanel from "../../../global/CompetitiveColorsPanel";
import Modal from "../../../../components/global/generic/Modal";
import CancelButton from "../../../global/generic/CancelButton";

import imgLoad from "../../../../resources/img/svgicons/load-formula.svg";

class ClosestColorsModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedFandeck: null,
            selectedColor: null,
            selectedDelta: 0
        };
    }

    selectFandeckAndColor = (fandeck, color, delta) => {
        this.setState({selectedFandeck: fandeck, selectedColor: color, selectedDelta: delta});
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleLoadButtonClick = () => {
        if (this.state.selectedColor !== null) {
            this.props.dispatchSelectClosestAction(
                this.props.tabId,
                this.props.product,
                this.state.selectedFandeck,
                this.state.selectedColor,
                this.state.selectedDelta
            );
        }
    };

    getLoadButton = () => {
        if (this.state.selectedColor !== null) {
            return (
                <button className="btn btn-info" onClick={this.handleLoadButtonClick}>
                    <ReactSVG className="pull-left load-icon" src={imgLoad} alt="Load formula" />
                    <Translate value="general.loadFormula" />
                </button>
            );
        }

        return (
            <button className="btn btn-info disabled">
                <ReactSVG className="pull-left load-icon" src={imgLoad} alt="Load formula" />
                <Translate value="general.loadFormula" />
            </button>
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button
                    label={<Translate value="general.loadFormula" />}
                    svgBefore={imgLoad}
                    onClick={this.handleLoadButtonClick}
                    disabled={this.state.selectedColor === null}
                />
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(
                    <Translate value="environmentsSettings.competitiveColorSearch" />
                )}
                content={modelHelper.buildModalSection(
                    <CompetitiveColorsPanel
                        tabId={this.props.tabId}
                        compFandeckId={
                            this.props.params.original === null ? null : this.props.params.original.fandeckId
                        }
                        compColorId={this.props.params.original === null ? null : this.props.params.original.id}
                        productId={null}
                        fandeckId={null}
                        originalRgb={this.props.params.original === null ? null : this.props.params.original.rgb}
                        method={null}
                        bipp={null}
                        margin={null}
                        filtering={false}
                        pricing={false}
                        colorList={this.props.params.closest}
                        selectProduct={() => {}}
                        selectFandeckAndColor={this.selectFandeckAndColor}
                        reloadColorList={() => {}}
                        loadFormula={this.handleLoadButtonClick}
                    />
                )}
                footer={this.getFooter()}
                styles={{width: "75%"}}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    if (store.formula[ownProps.tabId] === undefined) {
        return {
            product: null
        };
    }
    return {
        product: store.formula[ownProps.tabId].product
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.CLOSEST_COLORS_MODAL));
        },
        dispatchSelectClosestAction: (tabId, product, fandeck, color, delta) => {
            dispatch(searchPanelActions.selectClosestColorAndFandeck(tabId, product, fandeck, color, delta));
        }
    };
};

export default ClosestColorsModal = connect(mapStoreToProps, mapDispatchToProps)(ClosestColorsModal);
